import Vue from 'vue'

const Lang = {
    _locale: 'pt',
    $bus: new Vue(),

    discoverLocale() {
        let element = document.head.querySelector('meta[name="locale"]');

        if(!element) {
            console.error("Could not find Locale element in page!");
            this._locale = 'pt';
            return;
        }

        this._locale = element.content;

        if (!this._locale) {
            console.error("Invalid Locale element in page!");
            this._locale = 'pt';
        }

        this._defaultLocale = this._locale;

        console.info("Current locale: ", this._locale);
    },

    plugin: function (Vue, options) {
        console.log("Configured locale Vue service");
        Vue.prototype.$lang = window.Lang;
    },

    setDefaultLocale(locale) {
        console.log("Setting default locale: ", locale);
        this._defaultLocale = locale;
        this.$bus.$emit('locale', locale);
    },

    resolveDefaultLocale(locales) {
        if (this._defaultLocale) {
            return this._defaultLocale;
        }

        if (locales.length === 0) {
            return 'pt';
        }

        return locales[0];
    },

    get(key, lang) {
        if (!this._locale) {
            return key;
        }

        if (!window.__messages) {
            console.warn("Locale messages not loaded!");
            return key;
        }

        if (!window.__messages.hasOwnProperty(this._locale)) {
            console.warn(`Locale does not exist: ${this._locale}`);
            return key;
        }

        if (lang !== undefined) {
            return window.__messages[lang][key] || key;
        }

        return window.__messages[this._locale][key] || key;
    }
}

export default Lang;
